import { render, staticRenderFns } from "./AdminExclusiveProjectOrderControls.vue?vue&type=template&id=6ace3389"
import script from "./AdminExclusiveProjectOrderControls.vue?vue&type=script&lang=js"
export * from "./AdminExclusiveProjectOrderControls.vue?vue&type=script&lang=js"
import style0 from "../../../styles/home-page/admin.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports